import React from "react";

function HomeWorkoutEquipmentsPoster() {
  return (
    <div>
      <div className="page-desc">
        <div className="page-desc-content">
          <h3>Equipments</h3>
          <h1>Home Workout</h1>
        </div>
      </div>
    </div>
  );
}

export default HomeWorkoutEquipmentsPoster;
